/**
 * CollapsibleFilters — Batch #14.289 (mobile) : sur petit écran, les filtres se replient derrière un bouton « Filtres (n) » ;
 * sur md+ ils restent toujours visibles. `always` = contenu (ex. recherche) affiché même replié.
 */
import { useState } from "react";
import { ChevronDown, SlidersHorizontal } from "lucide-react";

export default function CollapsibleFilters({ active = 0, always = null, children, className = "", testId = "filters" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={testId}>
      {always}
      <button type="button" onClick={() => setOpen((o) => !o)}
        className={`md:hidden inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-lg border transition ${active ? "border-emerald-300 bg-emerald-50 text-emerald-800" : "border-slate-200 bg-white text-slate-600"}`}
        aria-expanded={open} data-testid={`${testId}-toggle`}>
        <SlidersHorizontal className="w-3.5 h-3.5" /> Filtres{active ? ` (${active})` : ""} <ChevronDown className={`w-3.5 h-3.5 transition ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`${open ? "flex" : "hidden"} flex-wrap items-center gap-2 w-full md:contents`} data-testid={`${testId}-body`}>
        {children}
      </div>
    </div>
  );
}
